var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 8.99973V13.4997M11.5312 6.18722H7.65C5.75982 6.18722 4.81473 6.18722 4.09278 6.55507C3.45773 6.87864 2.94143 7.39495 2.61785 8.03C2.25 8.75196 2.25 9.69705 2.25 11.5872V12.9372C2.25 13.9856 2.25 14.5097 2.42127 14.9233C2.64963 15.4745 3.08765 15.9126 3.63896 16.141C4.05245 16.3122 4.57664 16.3122 5.625 16.3122V21.0935C5.625 21.3547 5.625 21.4853 5.63583 21.5952C5.74106 22.6635 6.58621 23.5087 7.65447 23.6139C7.76447 23.6247 7.89506 23.6247 8.15625 23.6247C8.41744 23.6247 8.54804 23.6247 8.65805 23.6139C9.72629 23.5087 10.5715 22.6635 10.6767 21.5952C10.6875 21.4853 10.6875 21.3547 10.6875 21.0935V16.3122H11.5312C13.5184 16.3122 15.9494 17.3775 17.8248 18.3999C18.9189 18.9962 19.466 19.2945 19.8243 19.2506C20.1565 19.2099 20.4077 19.0607 20.6025 18.7884C20.8125 18.4949 20.8125 17.9075 20.8125 16.7326V5.76679C20.8125 4.59197 20.8125 4.00455 20.6025 3.71097C20.4077 3.43873 20.1565 3.28955 19.8243 3.24886C19.466 3.20498 18.9189 3.50319 17.8248 4.09962C15.9494 5.12197 13.5184 6.18722 11.5312 6.18722Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTrip);
export default __webpack_public_path__ + "static/media/new-trip.402eda3e3c90037972477c06562d7d6e.svg";
export { ForwardRef as ReactComponent };